import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("p", { class: "d-flex align-items-center justify-content-end mb-0" }, "Số lượng", -1)
const _hoisted_2 = { class: "text-end mb-0" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "d-flex align-items-center justify-content-end mb-0" }, [
  /*#__PURE__*/_createElementVNode("strong", null, " Đơn giá ")
], -1)
const _hoisted_4 = { class: "text-end mb-0" }
const _hoisted_5 = { class: "text-end" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", { class: "d-flex align-items-center justify-content-end mb-0" }, [
  /*#__PURE__*/_createElementVNode("strong", null, " Thành tiền ")
], -1)
const _hoisted_7 = { class: "text-end mb-0" }
const _hoisted_8 = { class: "d-flex justify-content-center flex-wrap" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_word_break_column = _resolveComponent("word-break-column")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_ButtonCustom = _resolveComponent("ButtonCustom")!
  const _component_el_table = _resolveComponent("el-table")!

  return (_openBlock(), _createBlock(_component_el_table, {
    border: true,
    "cell-class-name": _ctx.isTextDangerColumn,
    "cell-style": {padding: '0', height: '15px'},
    data: _ctx.items,
    "empty-text": _ctx.emptyText,
    size: "small"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_el_table_column, {
        label: "ID",
        width: "50"
      }, {
        default: _withCtx((scope) => [
          _createTextVNode(_toDisplayString(scope.row.id), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_word_break_column, {
        "header-title": "Tên vật tư",
        property: "ten_vat_tu"
      }),
      _createVNode(_component_el_table_column, {
        label: "Mã VT",
        width: "80"
      }, {
        default: _withCtx((scope) => [
          _createTextVNode(_toDisplayString(scope.row.ma_vat_tu), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_el_table_column, {
        label: "Thu hồi",
        width: "70"
      }, {
        default: _withCtx((scope) => [
          _createVNode(_component_el_checkbox, {
            modelValue: _ctx.items[scope.$index].thu_hoi,
            "onUpdate:modelValue": ($event: any) => ((_ctx.items[scope.$index].thu_hoi) = $event),
            disabled: ""
          }, null, 8, ["modelValue", "onUpdate:modelValue"])
        ]),
        _: 1
      }),
      _createVNode(_component_el_table_column, {
        label: "C/ty duyệt",
        width: "90"
      }, {
        default: _withCtx((scope) => [
          _createVNode(_component_el_checkbox, {
            modelValue: _ctx.items[scope.$index].cong_ty_duyet,
            "onUpdate:modelValue": ($event: any) => ((_ctx.items[scope.$index].cong_ty_duyet) = $event),
            disabled: ""
          }, null, 8, ["modelValue", "onUpdate:modelValue"])
        ]),
        _: 1
      }),
      _createVNode(_component_el_table_column, {
        label: "Trạng thái",
        width: "90"
      }, {
        default: _withCtx((scope) => [
          _createTextVNode(_toDisplayString(_ctx.isValidLabel(scope.row)), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_el_table_column, {
        label: "ĐVT",
        width: "60"
      }, {
        default: _withCtx((scope) => [
          _createTextVNode(_toDisplayString(scope.row.don_vi_tinh ?? '-'), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_el_table_column, { width: "95" }, {
        header: _withCtx(() => [
          _hoisted_1
        ]),
        default: _withCtx((scope) => [
          _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.formatCurrencyAndQuantity(scope.row.pivot.so_luong)), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_el_table_column, { width: "95" }, {
        header: _withCtx(() => [
          _hoisted_3
        ]),
        default: _withCtx((scope) => [
          _createElementVNode("p", _hoisted_4, [
            _createElementVNode("strong", _hoisted_5, _toDisplayString(_ctx.donGiaDisplay(scope.$index)), 1)
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_el_table_column, { width: "110" }, {
        header: _withCtx(() => [
          _hoisted_6
        ]),
        default: _withCtx((scope) => [
          _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.thanhTienDisplay(scope.$index)), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_el_table_column, {
        width: _ctx.widthComputed,
        fixed: "right"
      }, {
        default: _withCtx((scope) => [
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_ButtonCustom, {
              "color-type": _ctx.ButtonTypeColors.INFO,
              "button-type": _ctx.ButtonsType.INFO,
              onClick: ($event: any) => (_ctx.push(`/quan-ly/vat-tu/chi-tiet/${scope.row.id}`))
            }, null, 8, ["color-type", "button-type", "onClick"]),
            (_ctx.isDeleteButtonDisplay)
              ? (_openBlock(), _createBlock(_component_ButtonCustom, {
                  key: 0,
                  "color-type": _ctx.ButtonTypeColors.DANGER,
                  "button-type": _ctx.ButtonsType.TRASH,
                  onClick: ($event: any) => (_ctx.onDeleteVatTuClicked(scope.row))
                }, null, 8, ["color-type", "button-type", "onClick"]))
              : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      }, 8, ["width"])
    ]),
    _: 1
  }, 8, ["cell-class-name", "data", "empty-text"]))
}